<template>
  <el-select v-bind="$attrs" v-model="curSelect">
    <el-option
      v-for="item in optionsList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'HeTongLeiXing',
  components: {},
  computed: {},
  model: {
    prop: 'value'
  },
  props: {
    value: {type: [String, Number], default: ''},
    limit: {type: Number, default: 10000000}
  },
  data() {
    return {
      optionsList:[
        {
          value:'1',
          label:'销售'
        },
        {
          value:'2',
          label:'原材料采购合同'
        },
        {
          value:'3',
          label:'其他采购合同'
        },
        {
          value:'4',
          label:'HCP/HCO合同'
        },
        {
          value:'5',
          label:'保密协议'
        },
        {
          value:'6',
          label:'MTA协议'
        },
        {
          value:'7',
          label:'质量保证协议'
        },
        {
          value:'8',
          label:'其他协议'
        },
      ],
      curSelect: this.value
    };
  },
  mounted() {

  },

  watch: {
    value(newval) {
      this.curSelect = newval;
    },
    curSelect(newval) {
      this.$emit('input', newval)
    }

  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/projectComponents/HeTongLeiXing.vue